import { combineReducers } from 'redux';
import { CurrentBooking } from './reducer_currentBooking';
import { SetCollapse } from './reducer_utils';
import { SetDepartures } from './reducer_departures';

const rootReducer = combineReducers({
    currentBooking:CurrentBooking,
    toggleCollapse:SetCollapse,
    departures:SetDepartures
});
  
export default rootReducer;